<template>
<v-main>
  <v-layout class="ma-2" justify-center>
    <v-card class="px-4 rounded-xl" width="1200">
      <v-card-title>
        Alterar dados Apoio
      </v-card-title>
      <v-divider class="mb-2" />
      <v-text-field v-model="login" disabled :type="'text'" name="input-10-1" label="Login" counter @click:append="show1 = !show1"></v-text-field>

      <v-form v-model="valid" ref="form">
        <v-text-field label="Nome completo" v-model="nome" :rules="nameRules" required></v-text-field>

        <div v-if="checkboxSenha">
          <v-text-field v-model="novaSenha" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="Senha" counter @click:append="show1 = !show1"></v-text-field>
        </div>

        <v-checkbox v-model="checkboxSenha" label="Deseja alterar a Senha ?"></v-checkbox>

        <v-alert :value="erroLogin" color="error" icon="warning" outlined>
          Username já existente!
        </v-alert>

        <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
          Apoio alterado com sucesso!
        </v-alert>
        <v-card-actions>
          <v-spacer />

        <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
        <v-btn rounded outlined to='/listaApoioUnidade'>
          <v-icon left>keyboard_backspace</v-icon>
          voltar
        </v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'cadastrarAtendenteUnidade',
  data () {
    return {
      show1: false,
      valid: false,
      tipo: 7,
      idLocalEscolhida: '',
      erroLogin: false,
      login: '',
      sucessoLogin: false,
      novaSenha: '',
      respostaServidor: '',
      idUnidadeEscolhida: '',
      username: '',
      nome: '',
      listaLocais: [],
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 5 || 'Senha deve ter mais de 6 caracteres'
      ],
      nameRules: [
        (v) => !!v || 'Username obrigatório',
        (v) => v && v.length > 7 || 'Username deve ter mais de 7 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false,
      checkboxSenha: false

    }
  },
  components: {
    // HelloWorld
  },
  methods: {

    retornarLocais () {
      console.log('em retornar unidades adm...')
      administradorUnidadeService.administradorUnidade
        .retornarLocais(this.user.idEmpresa)
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.listaLocais = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    clear () {
      this.$refs.form.reset()
      this.erroLogin = false
    },

    submit () {
      if (this.$refs.form.validate()) {
        if (!this.checkboxSenha) {
          console.log('zerar senha..')
          this.novaSenha = ''
        }
        this.sucessoLogin = false
        this.erroLogin = false

        console.log('form valido')
        administradorUnidadeService.administradorUnidade
          .alterarFuncionario(this.idLocalEscolhida, this.nome, this.tipo, this.login, this.novaSenha)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data.msg)
            if (rsp.data == 'usernameExistente') {
              this.erroLogin = true
            }
            if (rsp.data == true) {
              this.sucessoLogin = true
              this.clear()
              setTimeout(() => this.$router.push({
                path: '/listaApoioUnidade'
              }), 2000)
            }

            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    limpar () {
      this.senha = ''
      this.nome = ''
      this.idUnidadeEscolhida = ''
    }

  },
  created () {
    console.log('created...')
  },
  mounted () {
    console.log('em mounted lista unid...')
    // console.log(this.user);
    if (!this.$route.params.item) {
      this.$router.push('/listaApoioUnidade')
      return
    }

    this.limpar()
    this.login = this.$route.params.item.username
    this.nome = this.$route.params.item.nome
    this.idLocalEscolhida = this.$route.params.item.idLocal

    this.user = this.$store.getters.usuario

    this.retornarLocais()
  }
}
</script>
